module.exports = __webpack_public_path__ + "assets/img/hangzhou.8a0e92a1.png";